import * as React from "react";
const useMutationConfig = ({ onError, onCompleted } = {}) => {
  const handleMutationError = React.useCallback(
    (error) => {
      onError?.({ reason: "MUTATION", error });
    },
    [onError]
  );
  const mutationOptions = React.useMemo(
    () => ({
      onError: handleMutationError,
      onCompleted: (data) => {
        onCompleted?.(data);
      }
    }),
    [handleMutationError, onCompleted]
  );
  return { mutationOptions };
};
export {
  useMutationConfig
};
//# sourceMappingURL=use-mutation-config.js.map
